import { render, staticRenderFns } from "./mv.vue?vue&type=template&id=138f9d3e&scoped=true&"
import script from "./mv.vue?vue&type=script&lang=js&"
export * from "./mv.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./mv.vue?vue&type=style&index=0&id=138f9d3e&lang=scss&scoped=true&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "138f9d3e",
  "af61d0ac"
  
)

export default component.exports